import { type BindingScope, injectable } from 'inversify';
import { dependencyContainer } from '../config/di-container';
import { IS_LOCAL } from '../config/env';

function Injectable(scope: BindingScope = 'Singleton') {
  return (target: abstract new (...args: never[]) => unknown) => {
    if (IS_LOCAL) {
      console.debug('Injectable registered', target.name);
    }

    injectable()(target);

    const binding = dependencyContainer.bind(target).toSelf();
    if (scope === 'Singleton') {
      binding.inSingletonScope();
    } else if (scope === 'Transient') {
      binding.inTransientScope();
    } else if (scope === 'Request') {
      binding.inRequestScope();
    }
  };
}

export { Injectable };
